import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import type { QuizWho } from "./types";

export interface QuizStepWhoProps {
  value: QuizWho | "";
  onChange: (who: QuizWho) => void;
  error: string | null;
  assetUrl: string;
}

const OPTIONS: {
  value: QuizWho;
  label: string;
  icon: string;
  iconHover: string;
}[] = [
  {
    value: "your",
    label: "Me",
    icon: "BF_Quiz_Icon_Me_white.svg",
    iconHover: "BF_Quiz_Icon_Me.svg",
  },
  {
    value: "child",
    label: "My child",
    icon: "BF_Quiz_Icon_My_child_white.svg",
    iconHover: "BF_Quiz_Icon_My_child.svg",
  },
  {
    value: "their",
    label: "Another adult",
    icon: "BF_Quiz_Icon_Another_adult_white.svg",
    iconHover: "BF_Quiz_Icon_Another_adult.svg",
  },
];

export const QuizStepWho: React.FC<QuizStepWhoProps> = ({
  value,
  onChange,
  error,
  assetUrl,
}) => {
  const handleChange = (who: QuizWho) => {
    onChange(who);
  };

  return (
    <motion.li
      className="step"
      data-step="who"
      initial={{ opacity: 0, x: 24 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -24 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
    >
      <div className="quiz-inner">
        <div className="quiz-title" data-question-type="title">
          <h2>Who are we helping today?</h2>
        </div>
        <div data-question-type="input-variable">
          <ol className="quiz-cards">
            {OPTIONS.map((opt) => (
              <li
                key={opt.value}
                className={`quiz-card-radio ${value === opt.value ? "selected" : ""}`}
              >
                <label htmlFor={`step-who-radio-${opt.value}`}>
                  <input
                    type="radio"
                    name="quiz-step-who"
                    id={`step-who-radio-${opt.value}`}
                    value={opt.value}
                    checked={value === opt.value}
                    onChange={() => handleChange(opt.value)}
                  />
                  <div
                    className="quiz-box"
                    style={{ backgroundImage: `url('${assetUrl}${opt.icon}')` }}
                  >
                    <div
                      className="quiz-box--hover"
                      style={{
                        backgroundImage: `url('${assetUrl}${opt.iconHover}')`,
                      }}
                    />
                  </div>
                  <div className="quiz-label">{opt.label}</div>
                </label>
              </li>
            ))}
          </ol>
        </div>
        <AnimatePresence mode="wait">
          {error && (
            <motion.div
              key={error}
              className="quiz-error"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -4 }}
              transition={{ duration: 0.2, ease: "easeOut" }}
            >
              {error}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </motion.li>
  );
};
